var objectToString = Object.prototype.toString

module.exports = objectToString



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticObjectToString.js
// module id = 537
// module chunks = 75